import { render, staticRenderFns } from "./ShowNewsletter.vue?vue&type=template&id=491f7865&scoped=true&"
import script from "./ShowNewsletter.vue?vue&type=script&lang=js&"
export * from "./ShowNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491f7865",
  null
  
)

export default component.exports